import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/articles';

export default function Navbar() {
  const { t } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70' : 'bg-transparent'}`}>
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <span className="text-xl font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors whitespace-nowrap">
              {t('site.name')}
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link to="/" className={`px-4 py-2 text-sm rounded-lg transition-colors whitespace-nowrap ${pathname === '/' ? 'text-primary-600 bg-primary-50 font-medium' : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'}`}>
              {t('nav.home')}
            </Link>
            <Link to="/category/all" className={`px-4 py-2 text-sm rounded-lg transition-colors whitespace-nowrap ${pathname.startsWith('/category') ? 'text-primary-600 bg-primary-50 font-medium' : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'}`}>
              {t('nav.category')}
            </Link>
            {categories.map((cat) => (
              <Link key={cat.slug} to={`/category/${cat.slug}`} className={`px-3 py-2 text-sm rounded-lg transition-colors whitespace-nowrap ${pathname === `/category/${cat.slug}` ? 'text-primary-600 bg-primary-50 font-medium' : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'}`}>
                {t(`nav.${cat.slug}`)}
              </Link>
            ))}
            <Link to="/about" className={`px-4 py-2 text-sm rounded-lg transition-colors whitespace-nowrap ${pathname === '/about' ? 'text-primary-600 bg-primary-50 font-medium' : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'}`}>
              {t('nav.about')}
            </Link>
          </div>

          <button onClick={() => setMobileOpen(!mobileOpen)} className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors" aria-label="Toggle menu">
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="flex flex-col p-4 gap-1">
            <Link to="/" className={`px-4 py-3 text-sm rounded-lg transition-colors ${pathname === '/' ? 'text-primary-600 bg-primary-50 font-medium' : 'text-foreground-700'}`}>{t('nav.home')}</Link>
            <Link to="/category/all" className={`px-4 py-3 text-sm rounded-lg transition-colors ${pathname.startsWith('/category') ? 'text-primary-600 bg-primary-50 font-medium' : 'text-foreground-700'}`}>{t('nav.category')}</Link>
            {categories.map((cat) => (
              <Link key={cat.slug} to={`/category/${cat.slug}`} className={`px-4 py-3 text-sm rounded-lg transition-colors ${pathname === `/category/${cat.slug}` ? 'text-primary-600 bg-primary-50 font-medium' : 'text-foreground-700'}`}>{t(`nav.${cat.slug}`)}</Link>
            ))}
            <Link to="/about" className={`px-4 py-3 text-sm rounded-lg transition-colors ${pathname === '/about' ? 'text-primary-600 bg-primary-50 font-medium' : 'text-foreground-700'}`}>{t('nav.about')}</Link>
          </div>
        </div>
      )}
    </nav>
  );
}